import { useState } from "react";

const P = {
  bg:"#080B14", card:"#0D1020", border:"#1D2238",
  gold:"#E9622A",
  text:"#EBE8F5", muted:"#8A8EAE",
  green:"#5BB87A", red:"#C46B6B", blue:"#5A82B8",
};

// ── PROPS ─────────────────────────────────────────────────────────────────────
// corsi         : array
// onSaveCorso   : async fn(payload, editTargetId|null) → aggiorna DB + state in App
// onDeleteCorso : async fn(id)
// maestriDB     : array — [{ id, nome, cognome, ... }]
// isMobile      : bool
// notify        : fn(msg, tipo)

const FORM_VUOTO = {
  nome: '', tipo: 'singolo',
  // singolo
  maestro: '', quotaOraria: 0,
  // condivisi
  durataLezioneOre: 2, lezioniMensili: 2,
  // multi
  maestriMulti: [],
};

export default function DatabaseCorsi({ corsi, onSaveCorso, onDeleteCorso, maestriDB, isMobile, notify }) {
  const [dbSearch, setDbSearch]   = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editTarget, setEditTarget] = useState(null);
  const [dbForm, setDbForm]       = useState(FORM_VUOTO);

  const f  = (k) => (e) => setDbForm(p => ({ ...p, [k]: e.target.value }));
  const fn = (k) => (e) => setDbForm(p => ({ ...p, [k]: Number(e.target.value) }));

  const chiaveMaestro = (m) => `${m.nome} ${m.cognome}`.trim().toUpperCase();
  // Maestri archiviati esclusi, tranne quelli già scelti nel corso che si sta modificando
  const inUso = new Set([dbForm.maestro, ...(dbForm.maestriMulti || []).map(x => x.nome)]);
  const opzioniMaestri = maestriDB.filter(m => !m.archiviato || inUso.has(chiaveMaestro(m))).sort((a, b) =>
    `${a.nome} ${a.cognome}`.localeCompare(`${b.nome} ${b.cognome}`)
  );

  // ── gestione lista maestri multi ──────────────────────────────────────────
  const addMaestroMulti = () => {
    const primo = opzioniMaestri[0];
    setDbForm(p => ({
      ...p,
      maestriMulti: [...p.maestriMulti, { nome: primo ? chiaveMaestro(primo) : '', quotaOraria: 0 }]
    }));
  };
  const updateMaestroMulti = (idx, campo, val) => {
    setDbForm(p => {
      const aggiornati = p.maestriMulti.map((m, i) => i === idx ? { ...m, [campo]: val } : m);
      return { ...p, maestriMulti: aggiornati };
    });
  };
  const removeMaestroMulti = (idx) => {
    setDbForm(p => ({ ...p, maestriMulti: p.maestriMulti.filter((_, i) => i !== idx) }));
  };

  // ── open ──────────────────────────────────────────────────────────────────
  const openAdd = () => { setEditTarget(null); setDbForm(FORM_VUOTO); setShowModal(true); };

  const openEdit = (c) => {
    setEditTarget(c);
    if (c.tipo === 'multi') {
      setDbForm({
        nome: c.nome || '', tipo: 'multi',
        maestro: '',
        durataLezioneOre: c.durataLezioneOre || 2,
        lezioniMensili:   c.lezioniMensili   || 2,
        maestriMulti: (c.maestri || []).map(m => ({ nome: m.nome || '', quotaOraria: m.quotaOraria || 0 })),
      });
    } else {
      setDbForm({
        nome: c.nome || '', tipo: 'singolo',
        maestro: c.maestro || '',
        quotaOraria: c.quotaOraria || 0,
        durataLezioneOre: c.durataLezioneOre || 2,
        lezioniMensili: c.lezioniMensili || 2,
        maestriMulti: [],
      });
    }
    setShowModal(true);
  };

  // ── save ──────────────────────────────────────────────────────────────────
  const save = () => {
    if (!dbForm.nome.trim()) { notify('Il nome corso è obbligatorio', 'err'); return; }

    let payload;
    if (dbForm.tipo === 'multi') {
      if (dbForm.maestriMulti.length === 0) { notify('Aggiungi almeno un maestro', 'err'); return; }
      payload = {
        nome:             dbForm.nome.trim(),
        tipo:             'multi',
        durataLezioneOre: dbForm.durataLezioneOre || 1,
        lezioniMensili:   dbForm.lezioniMensili   || 1,
        maestri: dbForm.maestriMulti.map(m => ({
          nome:        m.nome.trim().toUpperCase(),
          quotaOraria: Number(m.quotaOraria) || 0,
        })),
        label: '',
      };
    } else {
      if (!dbForm.maestro.trim()) { notify('Seleziona un maestro', 'err'); return; }
      payload = {
        nome:             dbForm.nome.trim(),
        tipo:             'singolo',
        maestro:          dbForm.maestro.trim().toUpperCase(),
        durataLezioneOre: dbForm.durataLezioneOre || 1,
        lezioniMensili:   dbForm.lezioniMensili   || 1,
        quotaOraria:      Number(dbForm.quotaOraria) || 0,
        label:            '',
      };
    }

    onSaveCorso(payload, editTarget ? editTarget.id : null);
    setShowModal(false);
    notify('Salvato ✓', 'ok');
  };

  const deleteCorso = (id) => { onDeleteCorso(id); notify('Corso eliminato', 'ok'); };

  const filtrati = corsi.filter(c =>
    `${c.nome} ${c.maestro || ''} ${(c.maestri||[]).map(m=>m.nome).join(' ')}`.toLowerCase()
      .includes(dbSearch.toLowerCase())
  );

  // ── render ────────────────────────────────────────────────────────────────
  return (
    <div style={{ animation:'fi .35s ease' }}>

      {/* HEADER */}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:26, flexWrap:'wrap', gap:12 }}>
        <div>
          <div style={{ fontFamily:"'IBM Plex Mono',monospace", fontSize:11, letterSpacing:3, color:P.muted, marginBottom:7, textTransform:'uppercase' }}>ANAGRAFICA</div>
          <h1 style={{ fontFamily:"'Syne',sans-serif", fontSize:isMobile?22:32, fontWeight:800, letterSpacing:-0.5 }}>Database Corsi</h1>
        </div>
        <button onClick={openAdd} style={{ background:P.gold, color:'#fff', border:'none', padding:'10px 20px', borderRadius:8, cursor:'pointer', fontWeight:600, fontSize:15 }}>
          + Aggiungi
        </button>
      </div>

      {/* SEARCH */}
      <input placeholder="Cerca per nome o maestro..." value={dbSearch} onChange={e=>setDbSearch(e.target.value)}
        style={{ background:P.card, border:`1px solid ${P.border}`, color:P.text, padding:'9px 15px', borderRadius:8, width:'100%', maxWidth:320, fontSize:15, marginBottom:16, fontFamily:"'Syne',sans-serif" }}/>

      {/* LISTA */}
      <div style={{ background:P.card, border:`1px solid ${P.border}`, borderRadius:14, overflowX:'auto' }}>
        <table style={{ width:'100%', borderCollapse:'collapse', minWidth:500 }}>
          <thead>
            <tr style={{ borderBottom:`1px solid ${P.border}` }}>
              {['#','Corso','Tipo','Maestri / Dettagli',''].map(h => (
                <th key={h} style={{ padding:'12px 14px', textAlign:'left', fontFamily:"'IBM Plex Mono',monospace", fontSize:11, letterSpacing:2, color:P.muted, fontWeight:400 }}>{h.toUpperCase()}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtrati.length === 0 ? (
              <tr><td colSpan={5} style={{ padding:'48px 14px', textAlign:'center', color:P.muted, fontSize:16 }}>
                Nessun corso. Clicca "+ Aggiungi" per iniziare.
              </td></tr>
            ) : filtrati.map((c, i) => (
              <tr key={c.id}
                style={{ borderBottom: i < filtrati.length-1 ? `1px solid ${P.border}` : 'none' }}
                onMouseEnter={e=>e.currentTarget.style.background=`${P.gold}08`}
                onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                <td style={{ padding:'10px 14px', color:P.muted, fontSize:14 }}>{i+1}</td>
                <td style={{ padding:'10px 14px' }}>
                  <div style={{ fontSize:15, fontWeight:600, color:P.gold }}>{c.nome}</div>
                </td>
                <td style={{ padding:'10px 14px' }}>
                  {c.tipo === 'multi'
                    ? <span style={{ fontSize:12, padding:'2px 8px', borderRadius:20, background:`${P.blue}18`, color:P.blue, border:`1px solid ${P.blue}30` }}>MULTI</span>
                    : <span style={{ fontSize:12, padding:'2px 8px', borderRadius:20, background:`${P.gold}18`, color:P.gold, border:`1px solid ${P.gold}30` }}>SINGOLO</span>
                  }
                </td>
                <td style={{ padding:'10px 14px', fontSize:14, color:P.muted }}>
                  {c.tipo === 'multi' ? (
                    <div>
                      <div style={{ marginBottom:2 }}>{c.durataLezioneOre}h/lez · {c.lezioniMensili} lez/mese</div>
                      <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
                        {(c.maestri||[]).map((m,mi) => (
                          <span key={mi} style={{ fontSize:12, padding:'1px 7px', borderRadius:20, background:`${P.blue}12`, color:P.blue, border:`1px solid ${P.blue}25` }}>
                            {m.nome} · €{m.quotaOraria}/h
                          </span>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div style={{ marginBottom:2 }}>{c.maestro || '—'}</div>
                      {c.durataLezioneOre && c.lezioniMensili && c.quotaOraria > 0 ? (
                        <div style={{ fontSize:12, color:P.muted }}>
                          {c.durataLezioneOre}h/lez · {c.lezioniMensili} lez/mese · €{c.quotaOraria}/h
                          <span style={{ color:P.gold, marginLeft:6, fontWeight:600 }}>= €{c.quotaOraria * c.durataLezioneOre * c.lezioniMensili}/mese</span>
                        </div>
                      ) : null}
                    </div>
                  )}
                </td>
                <td style={{ padding:'10px 14px' }}>
                  <div style={{ display:'flex', gap:6 }}>
                    <button onClick={() => openEdit(c)} style={{ padding:'4px 10px', borderRadius:6, border:`1px solid ${P.border}`, background:'transparent', color:P.muted, cursor:'pointer', fontSize:13 }}>✏</button>
                    <button onClick={() => deleteCorso(c.id)} style={{ padding:'4px 10px', borderRadius:6, border:`1px solid ${P.red}30`, background:`${P.red}12`, color:P.red, cursor:'pointer', fontSize:13 }}>✕</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* MODAL */}
      {showModal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.6)', zIndex:200, display:'flex', alignItems:'center', justifyContent:'center' }}
          onClick={e=>{ if(e.target===e.currentTarget) setShowModal(false); }}>
          <div
            onKeyDown={e=>{ if(e.key==='Enter' && e.target.tagName!=='TEXTAREA' && e.target.tagName!=='BUTTON') { e.preventDefault(); save(); } }}
            style={{ background:P.card, border:`1px solid ${P.border}`, borderRadius:16, padding:28, width:440, maxWidth:'94vw', maxHeight:'90vh', overflowY:'auto' }}>

            <div style={{ fontSize:17, fontWeight:600, marginBottom:18, color:P.text }}>
              {editTarget ? 'Modifica corso' : 'Nuovo corso'}
            </div>

            {/* nome */}
            <div style={{ marginBottom:12 }}>
              <label style={{ fontSize:12, color:P.muted, display:'block', marginBottom:4, letterSpacing:1, textTransform:'uppercase' }}>Nome corso</label>
              <input type="text" value={dbForm.nome} onChange={f('nome')} placeholder="es: Musica d'insieme"
                style={{ width:'100%', background:P.bg, border:`1px solid ${P.border}`, borderRadius:8, padding:'8px 10px', color:P.text, fontSize:15 }}/>
            </div>

            {/* tipo toggle */}
            <div style={{ marginBottom:16 }}>
              <label style={{ fontSize:12, color:P.muted, display:'block', marginBottom:6, letterSpacing:1, textTransform:'uppercase' }}>Tipo corso</label>
              <div style={{ display:'flex', gap:8 }}>
                {['singolo','multi'].map(t => (
                  <button key={t} onClick={() => setDbForm(p => ({ ...p, tipo: t }))}
                    style={{ flex:1, padding:'8px', borderRadius:8, cursor:'pointer', fontWeight:600, fontSize:14,
                      border:`1px solid ${dbForm.tipo===t ? P.gold : P.border}`,
                      background: dbForm.tipo===t ? `${P.gold}18` : 'transparent',
                      color: dbForm.tipo===t ? P.gold : P.muted }}>
                    {t === 'singolo' ? '👤 Singolo maestro' : '👥 Multi maestro'}
                  </button>
                ))}
              </div>
            </div>

            {/* ── SINGOLO ── */}
            {dbForm.tipo === 'singolo' && (
              <>
                {/* durata e lezioni */}
                <div style={{ display:'flex', gap:10, marginBottom:14 }}>
                  <div style={{ flex:1 }}>
                    <label style={{ fontSize:12, color:P.muted, display:'block', marginBottom:4, letterSpacing:1, textTransform:'uppercase' }}>Durata lezione (ore)</label>
                    <input type="number" min="0.5" step="0.5" value={dbForm.durataLezioneOre} onChange={fn('durataLezioneOre')}
                      style={{ width:'100%', background:P.bg, border:`1px solid ${P.border}`, borderRadius:8, padding:'8px 10px', color:P.text, fontSize:15 }}/>
                  </div>
                  <div style={{ flex:1 }}>
                    <label style={{ fontSize:12, color:P.muted, display:'block', marginBottom:4, letterSpacing:1, textTransform:'uppercase' }}>Lezioni al mese</label>
                    <input type="number" min="1" value={dbForm.lezioniMensili} onChange={fn('lezioniMensili')}
                      style={{ width:'100%', background:P.bg, border:`1px solid ${P.border}`, borderRadius:8, padding:'8px 10px', color:P.text, fontSize:15 }}/>
                  </div>
                </div>

                {/* maestro + quota oraria */}
                <div style={{ marginBottom:14 }}>
                  <label style={{ fontSize:12, color:P.muted, display:'block', marginBottom:8, letterSpacing:1, textTransform:'uppercase' }}>Maestro del corso</label>
                  <div style={{ display:'flex', gap:8, alignItems:'center' }}>
                    {opzioniMaestri.length > 0 ? (
                      <select value={dbForm.maestro} onChange={f('maestro')}
                        style={{ flex:2, background:P.bg, border:`1px solid ${P.border}`, borderRadius:8, padding:'7px 10px', color:P.text, fontSize:14, cursor:'pointer' }}>
                        <option value="">— Seleziona —</option>
                        {opzioniMaestri.map(m => (
                          <option key={m.id} value={chiaveMaestro(m)}>{m.nome} {m.cognome}</option>
                        ))}
                      </select>
                    ) : (
                      <input type="text" value={dbForm.maestro} onChange={f('maestro')} placeholder="es: ANTONELLO BUONOCORE"
                        style={{ flex:2, background:P.bg, border:`1px solid ${P.border}`, borderRadius:8, padding:'7px 10px', color:P.text, fontSize:14 }}/>
                    )}
                    <div style={{ display:'flex', alignItems:'center', gap:4, background:P.bg, border:`1px solid ${P.border}`, borderRadius:8, padding:'7px 10px', flex:1 }}>
                      <span style={{ color:P.muted, fontSize:13 }}>€</span>
                      <input type="number" min="0" value={dbForm.quotaOraria} onChange={fn('quotaOraria')} placeholder="€/h"
                        style={{ background:'transparent', border:'none', color:P.text, width:'100%', fontSize:14, outline:'none' }}/>
                      <span style={{ color:P.muted, fontSize:12, whiteSpace:'nowrap' }}>/h</span>
                    </div>
                  </div>
                </div>

                {/* riepilogo costo */}
                {dbForm.maestro && dbForm.quotaOraria > 0 && (
                  <div style={{ background:`${P.gold}10`, border:`1px solid ${P.gold}30`, borderRadius:8, padding:'10px 12px', marginBottom:14 }}>
                    <div style={{ fontSize:11, color:P.gold, letterSpacing:1, textTransform:'uppercase', marginBottom:6 }}>Riepilogo costo per allievo</div>
                    <div style={{ fontSize:13, color:P.muted, marginBottom:2 }}>
                      {dbForm.maestro || '—'}: {dbForm.quotaOraria}€/h × {dbForm.durataLezioneOre}h × {dbForm.lezioniMensili} lez = <span style={{ color:P.text, fontWeight:600 }}>€{dbForm.quotaOraria * dbForm.durataLezioneOre * dbForm.lezioniMensili}</span>
                    </div>
                    <div style={{ borderTop:`1px solid ${P.gold}30`, marginTop:8, paddingTop:8, fontSize:14, color:P.gold, fontWeight:700 }}>
                      Totale: €{dbForm.quotaOraria * dbForm.durataLezioneOre * dbForm.lezioniMensili}/mese per allievo
                    </div>
                  </div>
                )}
              </>
            )}

            {/* ── MULTI ── */}
            {dbForm.tipo === 'multi' && (
              <>
                {/* durata e lezioni */}
                <div style={{ display:'flex', gap:10, marginBottom:14 }}>
                  <div style={{ flex:1 }}>
                    <label style={{ fontSize:12, color:P.muted, display:'block', marginBottom:4, letterSpacing:1, textTransform:'uppercase' }}>Durata lezione (ore)</label>
                    <input type="number" min="0.5" step="0.5" value={dbForm.durataLezioneOre} onChange={fn('durataLezioneOre')}
                      style={{ width:'100%', background:P.bg, border:`1px solid ${P.border}`, borderRadius:8, padding:'8px 10px', color:P.text, fontSize:15 }}/>
                  </div>
                  <div style={{ flex:1 }}>
                    <label style={{ fontSize:12, color:P.muted, display:'block', marginBottom:4, letterSpacing:1, textTransform:'uppercase' }}>Lezioni al mese</label>
                    <input type="number" min="1" value={dbForm.lezioniMensili} onChange={fn('lezioniMensili')}
                      style={{ width:'100%', background:P.bg, border:`1px solid ${P.border}`, borderRadius:8, padding:'8px 10px', color:P.text, fontSize:15 }}/>
                  </div>
                </div>

                {/* lista maestri */}
                <div style={{ marginBottom:14 }}>
                  <label style={{ fontSize:12, color:P.muted, display:'block', marginBottom:8, letterSpacing:1, textTransform:'uppercase' }}>Maestri del corso</label>
                  {dbForm.maestriMulti.map((m, idx) => (
                    <div key={idx} style={{ display:'flex', gap:8, alignItems:'center', marginBottom:8 }}>
                      <select value={m.nome} onChange={e => updateMaestroMulti(idx, 'nome', e.target.value)}
                        style={{ flex:2, background:P.bg, border:`1px solid ${P.border}`, borderRadius:8, padding:'7px 10px', color:P.text, fontSize:14, cursor:'pointer' }}>
                        <option value="">— Seleziona —</option>
                        {opzioniMaestri.map(om => (
                          <option key={om.id} value={chiaveMaestro(om)}>{om.nome} {om.cognome}</option>
                        ))}
                      </select>
                      <div style={{ display:'flex', alignItems:'center', gap:4, background:P.bg, border:`1px solid ${P.border}`, borderRadius:8, padding:'7px 10px', flex:1 }}>
                        <span style={{ color:P.muted, fontSize:13 }}>€</span>
                        <input type="number" min="0" value={m.quotaOraria} onChange={e => updateMaestroMulti(idx, 'quotaOraria', Number(e.target.value))}
                          placeholder="€/h"
                          style={{ background:'transparent', border:'none', color:P.text, width:'100%', fontSize:14, outline:'none' }}/>
                        <span style={{ color:P.muted, fontSize:12, whiteSpace:'nowrap' }}>/h</span>
                      </div>
                      <button onClick={() => removeMaestroMulti(idx)}
                        style={{ padding:'7px 10px', borderRadius:8, border:`1px solid ${P.red}30`, background:`${P.red}12`, color:P.red, cursor:'pointer', fontSize:13 }}>✕</button>
                    </div>
                  ))}
                  <button onClick={addMaestroMulti}
                    style={{ width:'100%', padding:'8px', borderRadius:8, border:`1px dashed ${P.border}`, background:'transparent', color:P.muted, cursor:'pointer', fontSize:14, marginTop:2 }}>
                    + Aggiungi maestro
                  </button>
                </div>

                {/* riepilogo costo */}
                {dbForm.maestriMulti.length > 0 && (
                  <div style={{ background:`${P.gold}10`, border:`1px solid ${P.gold}30`, borderRadius:8, padding:'10px 12px', marginBottom:14 }}>
                    <div style={{ fontSize:11, color:P.gold, letterSpacing:1, textTransform:'uppercase', marginBottom:6 }}>Riepilogo costo per allievo</div>
                    {dbForm.maestriMulti.map((m, idx) => (
                      <div key={idx} style={{ fontSize:13, color:P.muted, marginBottom:2 }}>
                        {m.nome || '—'}: {m.quotaOraria}€/h × {dbForm.durataLezioneOre}h × {dbForm.lezioniMensili} lez = <span style={{ color:P.text, fontWeight:600 }}>€{m.quotaOraria * dbForm.durataLezioneOre * dbForm.lezioniMensili}</span>
                      </div>
                    ))}
                    <div style={{ borderTop:`1px solid ${P.gold}30`, marginTop:8, paddingTop:8, fontSize:14, color:P.gold, fontWeight:700 }}>
                      Totale: €{dbForm.maestriMulti.reduce((s,m) => s + m.quotaOraria * dbForm.durataLezioneOre * dbForm.lezioniMensili, 0)}/mese per allievo
                    </div>
                  </div>
                )}
              </>
            )}

            <div style={{ display:'flex', gap:8, marginTop:18 }}>
              <button onClick={() => setShowModal(false)} style={{ flex:1, padding:'9px', borderRadius:8, border:`1px solid ${P.border}`, background:'transparent', color:P.muted, cursor:'pointer', fontSize:15 }}>Annulla</button>
              <button onClick={save} style={{ flex:1, padding:'9px', borderRadius:8, border:'none', background:P.gold, color:'#fff', cursor:'pointer', fontWeight:600, fontSize:15 }}>Salva</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
